$(document).ready(function () {
	let tmSearch;
	let $form = $('form.vg-search');
	let hSearchContent = $form.find('.vg-search-content');

	let $inputSearch = $('.search-input');

	$inputSearch.on('keyup', function () {
		$('.search-input').not(this).val($(this).val());

		let $self = $(this),
			$self_form = $self.closest('form'),
			tabID = $self_form.data('tab-id') || 1,
			$content = hSearchContent,
			search = $self.val();

		clearTimeout(tmSearch);

		if (search) {
			$.get('/search/lookup', {search: search}, function (data) {
				if (data.view) {
					$('.vg-search').find('.vg-search-content-body').html(data.view);
					$content.addClass('focused');

					let $panes = $content.find('.tab-pane');
					$panes.each(function () {
						let id = $(this).attr('id');
						$(this).attr('id', id + tabID)
					});

					let $links = $content.find('.nav-link');
					$links.each(function () {
						let href = $(this).attr('href');
						$(this).attr('href', href + tabID)
					});
				}
			});
		}
	});
});
